<template>
    <div class="agreement">
        <div class="main_wrap">
			 <!-- <h2 class="agreement_title">{{agreement.title}}</h2> -->
			 <div class="agreement_content">
				<div v-html="agreement.desc"></div>
			 </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { getBaseUrl } from '@/utils/baseUrl.js'
import axios from 'axios'
export default {
    name: 'Agreement',
    data() {
        return {
            params: {
				id: '',
				type: '',
				update_time: ''
			},
			agreement: {
				
			}
        }
    },
    created() {
		const id = this.$route.query.id
		const update_time = this.$route.query.time
		this.params.id = id
		this.params.update_time = update_time
        this.getAgreementDetail()
    },

    methods: {
        ...mapActions('withdrawal', ['agreementDetail']),
        downError(id) {
            let token = localStorage.getItem('token')
            window.open(getBaseUrl() + '/problem/import/download?token=' + encodeURIComponent(token) + '&id=' + id)
        },
        async getAgreementDetail() {
            let res = await this.agreementDetail(this.params)
            this.agreement = res.detail
            console.log(res, 'agreement')
        }
    }
}
</script>
<style lang="less" scoped>
    .main_wrap {
		background-color: #fff;
		padding: 20px;
		border-radius: 5px;
		box-sizing: border-box;
		position: relative;
		min-height: 550px;
	}
	.agreement_title{
		text-align: center;
		margin-bottom: 20px;
	}
</style>
